import {
  NewsPopular,
  NewsSearch,
  NewsSubscription,
  NewsTags,
  NewsThumbCard,
} from "@modules/study/common/news";
import PaginationComponent from "@unisearch/common/ui_element/pagination";
import React from "react";
import { useMediaQuery } from "react-responsive";
import styles from "./news_list.module.scss";

export const NewsList = ({
  newsList,
  tagsList,
  popularStories,
  format,
  handlePager,
  paginate,
}) => {
  const isMobile = useMediaQuery({
    query: "(max-width: 900px)",
  });

  const paginationHandler = (_, page) => {
    if (handlePager) {
      handlePager(page);
    }
  };

  return (
    <section>
      <div className="container">
        {newsList && newsList?.length < 1 ? (
          <h4 className="center">No result found</h4>
        ) : (
          <div className={styles.list_wrapper}>
            <div className={styles.left_side}>
              {isMobile && (
                <NewsSearch
                  customClasses={{
                    wrapperClass: styles.search_wrapper,
                  }}
                />
              )}
              <div className={styles.list}>
                {newsList &&
                  newsList.length > 0 &&
                  newsList.map((news, i) => (
                    <NewsThumbCard key={news?.newsId} data={news} />
                  ))}
              </div>
              {/* Pagination start*/}
              {paginate && paginate.total > parseInt(paginate.limit) && (
                <PaginationComponent
                  paginate={paginate}
                  paginationHandler={paginationHandler}
                />
              )}
              {/* Pagination end*/}
            </div>
            <div className={styles.right_side}>
              {!isMobile && <NewsSearch />}
              <NewsSubscription />
              <NewsPopular data={popularStories} />
              <NewsTags tagsList={tagsList} format={format} />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default NewsList;
